/* eslint-disable no-console */
/* eslint-disable max-len */
import { GlobalState } from '@leverege/ui-redux';
import { Toast, Dialogs } from '@leverege/ui-elements';
import Molten from '@leverege/molten';
import { ShareTemporaryUserAccess } from '@leverege/api-ui-user-management';
async function fileToBuffer(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = event => {
      const buffer = Buffer.from(event.target.result);
      resolve(buffer);
    };
    reader.onerror = error => {
      reject(error);
    };
    reader.readAsArrayBuffer(file);
  });
}

/**
 * 
 * @param {object} options
 * @param {string} options.locatorId
 * @param {string} options.locationId
 * @param {function} options.onClose
 */
export async function activate(options) {
  const {
    asset,
    assetId,
    onClose,
    onChange,
    actions,
    contactInfo,
    assetDetails,
    image
  } = options;
  const orgId = asset?.data?.organization?.id;
  const companyId = asset?.data?.company?.id;
  const locationId = asset?.data?.location?.id;
  onChange?.({
    data: 'loading',
    value: true
  });
  GlobalState.dispatch(async (dispatch, getState, {
    api
  }) => {
    let res;
    try {
      const fd = new FormData();
      const body = {
        contact: {
          ...contactInfo
        },
        assetDetails: {
          ...assetDetails
        }
      };
      fd.append('data', JSON.stringify(body));
      if (image) {
        const imageBuffer = await fileToBuffer(image);
        const type = image.type;
        const f = new Blob([imageBuffer], {
          type
        });
        fd.append('image', f);
      }
      if (orgId) {
        res = await api.interface(process.env.SYSTEM_ID, 'organization').obj(orgId).grp('companies').obj(companyId).grp('locations').obj(locationId).grp('assetsLocators').obj(assetId).srv('theftRecovery').patch('activate', fd, null, {
          headers: {
            contentType: null
          }
        });
      } else {
        res = await api.interface(process.env.SYSTEM_ID, 'company').obj(companyId).grp('locations').obj(locationId).grp('assetsLocators').obj(assetId).srv('theftRecovery').patch('activate', fd, null, {
          headers: {
            contentType: null
          }
        });
      }
    } catch (error) {
      console.error({
        err: error
      });
      Toast.error(['Error activating theft recovery', error.message]);
      onClose?.();
    }
    setTimeout(() => {
      GlobalState.dispatch(actions.get());
      const uiName = process.env.UI_NAME;
      const uiUrl = Molten.getConfig('theftRecoveryUri');
      const createdByUser = res.theftCase?.data?.contact?.name || '-';
      const currentSite = window.location.origin;
      const tempUser = res.tempUser;
      const {
        createdBy,
        id
      } = tempUser;
      tempUser.username = `${createdBy}::${id}`; // Server doesn't create this

      Dialogs.show({
        id: 'temporaryUserManagement.action.PostCreateShare',
        component: ShareTemporaryUserAccess,
        props: {
          actions,
          temporaryUser: tempUser,
          emailOptions: {
            uiName,
            createdByUser,
            currentSite
          },
          smsOptions: {
            uiName,
            createdByUser,
            currentSite
          },
          uiName,
          uiUrl
        }
      });
      onChange?.({
        data: 'loading',
        value: false
      });
      onClose?.();
    }, 2000);
  });
}
export async function deactivate(options) {
  const {
    asset,
    closeReason,
    closeNotes,
    assetId,
    actions,
    throwErr,
    onChange,
    onClose
  } = options;
  const orgId = asset?.data?.organization?.id;
  const companyId = asset?.data?.company?.id;
  const locationId = asset?.data?.location?.id;
  onChange?.({
    data: 'loading',
    value: true
  });
  GlobalState.dispatch(async (dispatch, getState, {
    api
  }) => {
    let res;
    try {
      if (orgId) {
        res = await api.interface(process.env.SYSTEM_ID, 'organization').obj(orgId).grp('companies').obj(companyId).grp('locations').obj(locationId).grp('assetsLocators').obj(assetId).srv('theftRecovery').patch('deactivate', {
          closeReason,
          closeNotes
        });
      } else {
        res = await api.interface(process.env.SYSTEM_ID, 'company').obj(companyId).grp('locations').obj(locationId).grp('assetsLocators').obj(assetId).srv('theftRecovery').patch('deactivate', {
          closeReason,
          closeNotes
        });
      }
      if (!res?.success) {
        Toast.error(['Error deactivating theft recovery']);
      }
    } catch (error) {
      console.error(error);
      Toast.error(['Error deactivating theft recovery', error.message]);
      if (throwErr) {
        throw error;
      }
    }
    setTimeout(() => {
      GlobalState.dispatch(actions.get());
      onChange?.({
        data: 'loading',
        value: false
      });
      onClose?.();
    }, 2000);
  });
}